import { siteConfig } from '../config/site';
import type { ServiceDefinition } from '../config/services';
export function buildWhatsAppUrl(message: string) { return `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(message)}`; }
export function buildServiceWhatsAppUrl(service: ServiceDefinition) { return buildWhatsAppUrl(service.whatsappMessage); }
